
































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import tableMixin from './tableMixin';
import TableTitle from './_tableTitle.vue';
import IconFont from '@/components/icons/IconFont.vue';
import PaginationBlock from '@/components/Pagination.vue';

const BooleanMap = new Map([
    [true, 'Да'], [false, 'Нет']
]);

@Component({
    components: {
        TableTitle,
        IconFont,
        PaginationBlock,
    },
})
export default class Table extends Mixins(tableMixin) {
    @Prop() rows!: Record<string, any>[];
    @Prop({ default: () => ([]) }) errorRows!: number[];

    booleanMap = BooleanMap;
    isActiveFieldNames = ['isActive', 'is_active', 'active'];

    getIsInactive(row: Record<string, any>): boolean {
        const matchedFieldName = this.isActiveFieldNames.find(name => name in row);
        if (!matchedFieldName) {
            return false;
        }

        if (row[matchedFieldName]) {
            return false;
        }

        return true;
    }

    shouldRenderLink(columnName: string) {
        return Boolean(
            // medicalServiceType is used as a consultation's title
            ['name', 'partnerName', 'title', 'fullName', 'medicalServiceType', 'nameString'].includes(columnName)
            && this.routeName
        );
    }

    shouldRenderExternalLink(columnName: string) {
        return Boolean(
            ['link'].includes(columnName),
        );
    }

}
